module.exports = __webpack_public_path__ + "07adb1d650bcb0d748891bf74410129b.png";